import { sum } from 'lib/array/arrayUtils'
import { createSelector } from 'reselect'
import getPassportCardTotalsWithoutInsurance from '../payment/getPassportCardTotalsWithoutInsurance'

const getPassportCardInsuranceCoverAmountFromCart = createSelector(
  (state: App.State) => getPassportCardTotalsWithoutInsurance(state),
  (totals): number | undefined => {
    if (totals.hasRequiredData) {
      const {
        paidPrice = 0,
        price = 0,
        surcharge = 0,
        otherFees = {},
      } = totals.data

      return paidPrice + price + surcharge + sum(Object.values(otherFees))
    }
  },
)

export default getPassportCardInsuranceCoverAmountFromCart
